export default [
    {
        type: 'stepped',
        curve: 'curveStepAfter',
        allowed: true,
    },
    {
        type: 'linear',
        curve: 'curveLinear',
        allowed: true,
    },
    {
        type: 'smooth',
        curve: 'curveMonotoneX',
        allowed: true,
    },
    {
        type: 'very smooth',
        curve: 'curveMonotoneX',
        allowed: true,
        isDeprecated: true,
    },
];
